exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".schedule-container[data-v-c00805fe]{background-color:#f5f5f5;overflow-y:scroll;height:calc(100vh - 192px)}.border-container[data-v-c00805fe]{border:1px solid;border-color:#ccc!important;border-radius:.5rem}[data-v-c00805fe] input.display-time.all-selected.disabled,[data-v-c00805fe] input[type=text]:disabled{color:#7b8d8f}", ""]);

// exports
